// NATIVE BRIDGE — what the web app calls, and what answers it inside the iPad app.
//
// The sign-in screen feature-detects `window.InCiteNative.scanBadge` and only shows the badge
// button when it is present (components/DeviceCheckIn.jsx). That check is the whole contract: in
// Safari it is absent and the DSP types an employee id; in the app it resolves to CoreNFC.
//
// Registered from the WEB side rather than injected by the native shell because the app loads the
// deployed site — so this ships with a hosting deploy and needs no App Store update to change.
export async function installNativeBridge() {
  if (typeof window === 'undefined') return
  const cap = window.Capacitor
  // Not running inside the native shell. Leaving InCiteNative undefined is deliberate: it is the
  // signal the UI uses to hide a button that could not work here.
  if (!cap?.isNativePlatform?.()) return

  const plugin = cap.Plugins?.BadgeReader
  if (!plugin) return

  // An iPad with no NFC hardware, or an OS that refuses — better to hide the button than to offer
  // one that always fails.
  try {
    const { available } = await plugin.isAvailable()
    if (!available) return
  } catch { return }

  window.InCiteNative = {
    /** Resolves to the card's UID as bare lowercase hex, or null when the user cancels the sheet. */
    scanBadge: async () => {
      const res = await plugin.scan()
      return res?.cancelled ? null : (res?.uid || null)
    },
  }
}
